import React from "react";
import "../Forms/css/addDirectory.css";
import { connect } from "react-redux";
import axios from "axios";
import { withRouter } from "react-router-dom";

const token = localStorage.getItem('authToken');

class AddCaste extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      caste: "",
      subcaste: "",
      gotra: "",
      submissionStatus: null,
      submeet: false,
    };
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ submeet: true });
    try {
      const { caste, subcaste, gotra } = this.state;
  
      const formData = new FormData();
      formData.append('caste', caste);
      if (subcaste) formData.append('subcaste', subcaste); // Append only if present
      if (gotra) formData.append('gotra', gotra); // Append only if present
  
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`
        }
      };
  
      const response = await axios.post("https://samaj.aasmo.in/api/admin/caste", formData, config);
      console.log('Response:', response);
  
      if (response && response.status === 201) {
        this.setState({ submissionStatus: 'success' });
        console.log('Form submitted successfully');
        setTimeout(() => {
           this.props.history.push('/casteList');
        }, 2000);
      } else {
        console.log('Unexpected response:', response);
      }
    } catch (error) {
      console.error('Error submitting form:', error);
      if (error.response && error.response.status === 400) {
        console.error('Bad request error:', error.response.data);
      } else if (error.response && error.response.status === 401) {
        console.error('Unauthorized error, please log in again.');
      }
    }
  };

  render() {
    const { submeet, caste, subcaste, gotra, submissionStatus } = this.state;

    const isValid = (value) => value && value.trim().length > 0;

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Add Caste</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit} className="ng-untouched ng-dirty ng-invalid">
              <div className="form-group">
                <label>Caste</label>
                <input
                  className={`form-control ${!isValid(caste) && submeet && "parsley-error"}`}
                  value={caste}
                  name="caste"
                  required
                  type="text"
                  onChange={(e) => {
                    this.setState({ caste: e.target.value });
                  }}
                />
                {submeet && !isValid(caste) && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>Sub Caste (Optional)</label>
                <input
                  className={`form-control ${submeet && subcaste !== "" && !isValid(subcaste) && "parsley-error"}`}
                  value={subcaste}
                  name="subcaste"
                  type="text"
                  onChange={(e) => {
                    this.setState({ subcaste: e.target.value });
                  }}
                />
                {submeet && subcaste !== "" && !isValid(subcaste) && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              <div className="form-group">
                <label>Gotra (Optional)</label>
                <input
                  className={`form-control ${submeet && gotra !== "" && !isValid(gotra) && "parsley-error"}`}
                  value={gotra}
                  name="gotra"
                  type="text"
                  onChange={(e) => {
                    this.setState({ gotra: e.target.value });
                  }}
                />
                {submeet && gotra !== "" && !isValid(gotra) && (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, {})(withRouter(AddCaste));
